import React from 'react'

// TODO: Use useTimer instead
export const Timer = ({ renderer, interval, stop }) => {
  const [time, setTime] = React.useState(0)
  React.useEffect(() => {
    const timerId = setInterval(
      () => setTime(oldTime => oldTime + interval),
      interval,
    )
    if (stop) clearInterval(timerId)
    return () => {
      clearInterval(timerId)
    }
  }, [stop])

  return renderer(time)
}
